<template>
  <div>
    <vx-card class="mb-6">
      <FiltroTabela @filtro="makeFiltro"></FiltroTabela>
    </vx-card>
    <vx-card>
      <ListTabelas
        :filtro="filtro"
        :realizaFiltro="realizaFiltro"
        @filtroOk="finalizaFiltro"
        :subjectPermission="subjectPermission">
      </ListTabelas>
    </vx-card>
  </div>
</template>

<script>
import ListTabelas from "./../../lists/ListTabelas";
import FiltroTabela from "./../../filtros/FiltroTabela";
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      subjectPermission: "Tabelas",
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
  },
  components: {
    ListTabelas,
    FiltroTabela,
  },
};
</script>
